import { useNavigate } from 'react-router-dom';
import { MouseEventHandler } from 'react';
import useCommonStore from 'store/useCommonStore';
import type { IRecommend } from 'store/type';

/** 추천 검색어 박스에서 사용할 이벤트들을 반환
 * @return selectEnter: 마우스를 올렸을 때
 * @return selectLeave: 마우스가 벗어났을 때
 * @return selectClick: 클릭했을 때
 */
const useRecommentEvent = () => {
	// router
	const navigate = useNavigate();

	// store
	const { setModalPosition, setKeyword, setSearchModal, setSelectedRecommend } =
		useCommonStore();

	// event
	const selectEnter = (selected: IRecommend) => setSelectedRecommend(selected);
	const selectLeave = () => setSelectedRecommend({ text: '', idx: null });
	const selectClick: MouseEventHandler<HTMLLIElement> = (e) => {
		const target_keyword = e.currentTarget.innerText;

		setSearchModal(false);
		setModalPosition({ top: null, left: null, right: null, bottom: null });
		navigate(`/imms/search?keyword=${target_keyword}`, { replace: true });
		setKeyword(target_keyword);
	};

	return [selectEnter, selectLeave, selectClick] as [
		(selected: IRecommend) => void,
		() => void,
		MouseEventHandler<HTMLLIElement>,
	];
};

export default useRecommentEvent;
